import FormatCurrency from 'components/Common/FormatCurrency'
import type { ComponentProps, ReactElement } from 'react'
import React from 'react'
import BodyText from '../Typography/BodyText'
import _PriceSummaryRow from './_PriceSummaryRow'

interface Props extends Utils.PropsWithDataAttributes {
  /**
   * Textual content at the start.
   */
  label: ReactElement | string
  labelStrikethrough?: boolean
  /**
   * Formatted price at the end.
   */
  value?: number
  valueStrikethrough?: boolean
  /**
   * @default preciseDollar
   */
  valueFormat?: ComponentProps<typeof FormatCurrency>['format']
}

function PriceSummaryRowItemDescription(props: Props) {
  const {
    label,
    labelStrikethrough,
    value,
    valueStrikethrough,
    valueFormat = 'preciseDollar',
    ...rest
  } = props

  return <_PriceSummaryRow
    {...rest}
    startSlot={<BodyText
      variant="medium"
      weight="normal"
      colour="neutral-two"
      lineClamp={2}
      strikeThrough={labelStrikethrough}
    >
      {label}
    </BodyText>}
    endSlot={value !== undefined && <BodyText
      variant="medium"
      weight="normal"
      colour="neutral-two"
      wrap="no-wrap"
      strikeThrough={valueStrikethrough}
    >
      <FormatCurrency value={value} format={valueFormat} />
    </BodyText>}
  />
}

export default PriceSummaryRowItemDescription
